<script setup lang="ts">
import { useLoginForm } from '@/composables/useLoginForm'

const { formState, handleSubmit } = useLoginForm()
</script>

<template>
  <div class="login-container">
    <h2 class="login-title">Login</h2>

    <form @submit.prevent="handleSubmit" class="login-form">
      <div class="form-field">
        <label for="username" class="form-label">Username</label>
        <input v-model="formState.username" type="text" id="username" name="username" class="form-input"
          :class="{ 'error': formState.errors.username.length > 0 }" placeholder="Enter your username"
          :disabled="formState.isSubmitting" />
        <div v-if="formState.errors.username.length > 0" class="error-messages">
          <p v-for="(error, index) in formState.errors.username" :key="index" class="error-text">
            {{ error }}
          </p>
        </div>
      </div>

      <div class="form-field">
        <label for="password" class="form-label">Password</label>
        <input v-model="formState.password" type="password" id="password" name="password" class="form-input"
          :class="{ 'error': formState.errors.password.length > 0 }" placeholder="Enter your password"
          :disabled="formState.isSubmitting" />
        <div v-if="formState.errors.password.length > 0" class="error-messages">
          <p v-for="(error, index) in formState.errors.password" :key="index" class="error-text">
            {{ error }}
          </p>
        </div>
      </div>

      <div v-if="formState.errors.general.length > 0" class="error-messages">
        <p v-for="(error, index) in formState.errors.general" :key="index" class="error-text">
          {{ error }}
        </p>
      </div>

      <button type="submit" class="login-button" :disabled="formState.isSubmitting">
        {{ formState.isSubmitting ? 'Logging in...' : 'Log In' }}
      </button>
    </form>
  </div>
</template>

<style scoped>
.login-container {
  @apply flex flex-col max-w-md w-full p-6 space-y-6 bg-white bg-opacity-90 shadow-lg;
}

.login-title {
  @apply text-2xl font-semibold text-center;
}

.login-form {
  @apply flex flex-col gap-3;
}

.form-field {
  @apply flex flex-col gap-1;
}

.form-label {
  @apply text-sm font-medium text-gray-700;
}

.form-input {
  @apply mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring focus:ring-blue-300;
}

.error-message {
  @apply text-red-500;
}

.login-button {
  @apply mt-4 w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300 disabled:opacity-50 disabled:cursor-not-allowed;
}

.form-input.error {
  @apply border-red-500 focus:ring-red-300;
}

.error-messages {
  @apply mt-1;
}

.error-text {
  @apply text-sm text-red-500;
}
</style>